import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * This component is a wrapper for all auth components like login, register or forgot-password.
 * It defines consistent layout for those pages.
 */
@Component({
  selector: 'ly-auth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
})
export class AuthComponent {}
